import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import bkimg from "../../images/bkuddin.png";
import "./AboutMeDetails.css";

const AboutMeDetails = () => {
  return (
    <div className="section">
      <Container>
        <Row>
          <Col sm={4}>
            <img className="bkimg" src={bkimg} alt="" />
          </Col>
          <Col sm={6}>
            <h2>I’M AVAILABLE</h2>
            <p className="text-section">
              Bakhtiar Hossain is my name. I am an obsessive seeker of
              information, occasional dispenser of wisdom, and, coincidentally,
              a graphic designer. Additionally, I appreciate simplifying
              complicated issues via the use of simple, elegant, and intuitive
              designs. When I'm not pixel-pushing, you'll find me writing,
              gardening, or exercising in the park. <br /> <br />
              THE CREDITORS <br /> <br /> Complete Web Development Course (HTML,
              CSS, Bootstrap, JavaScript, React, NodeJs, ExpressJs, MongoDB,
              etc.) – 2021
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutMeDetails;
